const initialState = {
  dayWiseBreakDownCollection: [],
  navData: {},
  breakDownView: false,
  breakDownCollectionSummary: {
    totalCollection: 0,
    walletUsage: 0,
    expense: 0,
    finalProfit: 0,
    netPayout: 0,
  },
};
export default initialState;
